import React, { useEffect } from "react";
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Auth0 from '../../store/actions/auth/Auth';
import authActions from '../../store/actions/auth';
import { serverLogout } from '../../data/user/actions';
import ErrorIcon from '../../assets/img/ErrorIcon.svg?react';

const SecuredRoute = ({ children, scopes }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isAuthenticated = Auth0.isAuthenticated();

  useEffect(() => {
    if (!isAuthenticated) {
      dispatch(authActions.signinUser());
    }
  }, [isAuthenticated, dispatch]);

  const handleSignout = async () => {
    await serverLogout();
    dispatch(authActions.signoutUser());
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  if (!isAuthenticated) {
    return <div className="result-page">Redirecting to login...</div>;
  }

  const hasScopes = Auth0.hasScopes(scopes);

  if (!hasScopes) {
    return (
      <div className="result-page">
        <ErrorIcon />
        <p className="result-message result-message--error">
          Ditt konto har inte tillgång till denna funktion. Om du precis
          fått nya rättigheter tilldelade till ditt konto, pröva att logga
          ut och sedan in igen.
        </p>
        <button className="btn btn--secondary" onClick={handleSignout}>
          Logga ut
        </button>{" "}
        <button className="btn btn--primary" onClick={handleGoBack}>
          Återgå till föregående sida
        </button>
      </div>
    );
  }

  return <>{children}</>;
};

export default SecuredRoute;
